import {createContext, useContext, useState, useEffect} from "react";
const CartContext = createContext();
export function useCartContext(){
    return useContext(CartContext);
}

export default function CartProvider({children}){
    const [items, setItems] = useState(_=>{
            const saved = localStorage.getItem("wwappCart");
            return saved?JSON.parse(saved):[];
    });
    const [wishList, setWishList] = useState(_=>{
        const wishList = localStorage.getItem("wwappWishList");
        return wishList?JSON.parse(wishList):[];
    })

    // [] persist through pages
    useEffect(_=>{
        localStorage.setItem("wwappCart", JSON.stringify(items));
        localStorage.setItem("wwappWishList", JSON.stringify(wishList));
    }, [wishList, items]);

    // [] helpers
    const addItem = (pdt, qty=1)=>{
        setItems(prev=>{
            const existing = prev.find(i=>i.__id === pdt.__id);
            
            // [] item in items already, increace qty
            if(existing){
                return prev.map(i=>i.__id === pdt.__id?{...i, qty: i.qty + qty}:i);
            }

            // [] item not in items yet, append item
            return [...prev, {...pdt, qty}]
        });
    };

    const removeItem = id=>{
        setItems(prev=>prev.filter(i=>i.__id !== id));
    };

    const updateItem = (id, qty)=>{
        setItems(prev=>prev.map(i=>i.__id === id?{...i, qty:Math.max(qty, 1)}:i));
    };

    const clearCart = _=>setItems([]);

    const totalItems = items.reduce((sum, i)=>sum + parseFloat(i.qty), 0);
    const totalPrice = items.reduce((sum, i)=>sum + parseFloat(i.price)*parseFloat(i.qty), 0);

    const addWishListItem = (pdt)=>{
        setWishList(prev=>{
            const existing = prev.find(i=>i.__id === pdt.__id);
            
            // [] item in items already, increace qty
            if(existing){
                return prev;
            }

            // [] item not in items yet, append item
            return [...prev, pdt]
        });
    }

    const removeWishListItem = id=>{
        setWishList(prev=>prev.filter(i=>i.__id !== id));
    };


    const clearWishList = _=>setWishList([]);

    const inWishList = pdt=>!!wishList.find(i=>i.__id === pdt.__id);

    return <CartContext.Provider
        value={{
            items,
            addItem,
            removeItem,
            updateItem,
            clearCart,
            totalItems,
            totalPrice,

            wishList,
            inWishList,
            addWishListItem,
            removeWishListItem,
            clearWishList
        }}    
    >
        {children}
    </CartContext.Provider>
}